import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18n";
import { MusicPlayerProvider } from "@/context/MusicPlayerContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/music/MusicLayout";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import MusicHome from "@/pages/music/MusicHome";
import MusicSearch from "@/pages/music/MusicSearch";
import MusicLibrary from "@/pages/music/MusicLibrary";
import PlaylistDetail from "@/pages/music/PlaylistDetail";
import ArtistDetail from "@/pages/music/ArtistDetail";
import AlbumDetail from "@/pages/music/AlbumDetail";
import LikedSongs from "@/pages/music/LikedSongs";
import Artists from "@/pages/music/Artists";
import Albums from "@/pages/music/Albums";
import Collections from "@/pages/music/Collections";
import CollectionDetail from "@/pages/music/CollectionDetail";
import Browse from "@/pages/music/Browse";
import ForYou from "@/pages/music/ForYou";
import GenreDetail from "@/pages/music/GenreDetail";
import MoodDetail from "@/pages/music/MoodDetail";
import Settings from "@/pages/Settings";

const Shell = () => (
  <ProtectedRoute>
    <MusicPlayerProvider>
      <AppShell />
    </MusicPlayerProvider>
  </ProtectedRoute>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <I18nProvider>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Auth mode="login" />} />
          <Route path="/register" element={<Auth mode="register" />} />
          <Route path="/app" element={<Shell />}>
            <Route index element={<MusicHome />} />
            <Route path="search" element={<MusicSearch />} />
            <Route path="browse" element={<Browse />} />
            <Route path="for-you" element={<ForYou />} />
            <Route path="artists" element={<Artists />} />
            <Route path="albums" element={<Albums />} />
            <Route path="collections" element={<Collections />} />
            <Route path="collection/:name" element={<CollectionDetail />} />
            <Route path="library" element={<MusicLibrary />} />
            <Route path="liked" element={<LikedSongs />} />
            <Route path="playlist/:id" element={<PlaylistDetail />} />
            <Route path="artist/:name" element={<ArtistDetail />} />
            <Route path="album/:id" element={<AlbumDetail />} />
            <Route path="genre/:name" element={<GenreDetail />} />
            <Route path="mood/:name" element={<MoodDetail />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </I18nProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
